<template>
  <div class="py-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="col-12">
              <div class="row">
                <div class="col-12 py-3 px-4 pt-4">
                  <h3
                    class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold"
                  >
                    Eventos
                  </h3>
                  <div class="row">
                    <div class="form-group col-12 col-md-6 col-lg-5 mb-1 px-0">
                      <label for="">Búsqueda</label>
                      <input
                        type="text"
                        placeholder="Buscar"
                        class="form-control form-control-sm mt-1 mb-4"
                        v-model="searchQuery"
                        @input="loadElements(1)"
                      />
                    </div>
                    <div class="col-12 col-md-6 p-0 mb-3 pt-md-4 pl-md-5">
                      <div
                        class="d-flex justify-content-md-end pr-0 mr-0 pl-0 pl-md-5 pt-md-2"
                      >
                        <button
                          type="button"
                          class="bg-primary text-white font-weight-normal border btn-outline-primary h5 mb-0 btn"
                          @click="goNew"
                        >
                          Crear Evento
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive card">
                    <table class="table table-sm table-hover">
                      <thead class="thead-light">
                        <tr>
                          <!--<th class="" scope="col">
                            <div class="font-weight-bold text-center">ID</div>
                          </th>-->

                          <th class="" scope="col">
                            <div class="font-weight-bold text-center">
                              Imagen
                            </div>
                          </th>
                          <th class="" scope="col">
                            <div class="font-weight-bold text-center">
                              Título
                            </div>
                          </th>
                          <th class="" scope="col">
                            <div class="font-weight-bold text-center">
                              Fecha
                            </div>
                          </th>
                          <th class="" scope="col">
                            <div class="font-weight-bold text-center">
                              Acciones
                            </div>
                          </th>
                          <th class="d-none"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="" v-for="item in events" :key="item.id">
                          <!--<td class="text-center">{{ item.id }}</td>-->

                          <td class="text-center d-flex justify-content-center">
                            <div
                              class="d-flex justify-content-center align-items-center bg-secondary rounded-lg"
                              :class="{
                                'shadow-sm rounded':
                                  item.url_image &&
                                  item.url_image !== 'null' &&
                                  item.url_image !== null
                              }"
                              style="
                                width: 35px;
                                height: 35px;
                                overflow: hidden;
                              "
                              :style="
                                !item.url_image ||
                                item.url_image === 'null' ||
                                item.url_image === null
                                  ? { opacity: 0.2 }
                                  : ''
                              "
                            >
                              <img
                                v-if="
                                  item.url_image &&
                                  item.url_image !== 'null' &&
                                  item.url_image !== null
                                "
                                :src="item.url_image"
                                alt=""
                                class="rounded-lg shadow-sm"
                                style="
                                  width: 100%;
                                  height: 100%;
                                  object-fit: cover;
                                "
                              />
                              <i
                                v-else
                                class="bi bi-file-earmark-image text-white"
                              ></i>
                            </div>
                          </td>
                          <td class="text-center">{{ item.title }}</td>
                          <td class="text-center">
                            {{ item.date.split('-').reverse().join('/') }}
                          </td>
                          <td class="text-center">
                            <div class="d-flex justify-content-center w-100">
                              <Tooltip text="Editar">
                                <button
                                  class="btn bg-warning border-0 p-2"
                                  @click="goEdit(item.id)"
                                >
                                  <i
                                    class="bi bi-pencil-square text-white d-flex justify-content-center align-items-center"
                                  ></i>
                                </button>
                              </Tooltip>

                              <Tooltip
                                :text="
                                  item.active === 1 ? 'Desactivar' : 'Activar'
                                "
                              >
                                <button
                                  class="btn border-0 mx-1 p-2"
                                  :class="{
                                    'bg-secondary': item.active === 0,
                                    'bg-success': item.active === 1
                                  }"
                                  @click="changeStatus(item.id, item.active)"
                                >
                                  <i
                                    v-if="item.active === 1"
                                    class="bi bi-check2-circle text-white d-flex justify-content-center align-items-center"
                                  ></i>
                                  <i
                                    v-else
                                    class="bi bi-eye-slash text-white d-flex justify-content-center align-items-center"
                                  ></i>
                                </button>
                              </Tooltip>

                              <Tooltip text="Eliminar">
                                <button
                                  class="btn bg-danger border-0 p-2 h-100"
                                  @click="
                                    changeStatus(item.id, item.active, true)
                                  "
                                >
                                  <i
                                    class="bi-trash3-fill text-white d-flex justify-content-center align-items-center"
                                  ></i>
                                </button>
                              </Tooltip>
                            </div>
                          </td>
                          <td class="d-none"></td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- Paginación -->
                    <div class="d-flex justify-content-center">
                      <nav aria-label="Page navigation example">
                        <ul class="pagination">
                          <li
                            class="page-item"
                            :class="{ disabled: currentPage === 1 }"
                          >
                            <a
                              class="page-link"
                              href="#"
                              @click.prevent="changePage(currentPage - 1)"
                              aria-label="Previous"
                            >
                              <span aria-hidden="true">&laquo;</span>
                            </a>
                          </li>
                          <li
                            class="page-item"
                            v-for="page in totalPages"
                            :key="page"
                          >
                            <a
                              class="page-link"
                              :class="{
                                'bg-primary ': page == currentPage,
                                'text-white': page === currentPage
                              }"
                              href="#"
                              @click.prevent="changePage(page)"
                              >{{ page }}</a
                            >
                          </li>
                          <li
                            class="page-item"
                            :class="{ disabled: currentPage === totalPages }"
                          >
                            <a
                              class="page-link"
                              href="#"
                              @click.prevent="changePage(currentPage + 1)"
                              aria-label="Next"
                            >
                              <span aria-hidden="true">&raquo;</span>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      events: [],
      searchQuery: '',
      currentPage: 1,
      totalPages: 0,
      limit: 20,
      buttonNewUrl: 'NewEvents',
      buttonEditUrl: 'EditEvents'
    }
  },
  methods: {
    ...mapActions(['getData', 'updateData', 'changeStatusData']),

    loadElements(page = 1) {
      const form = {
        url: 'event/all',
        params: {
          query: this.searchQuery,
          page: page,
          limit: this.limit,
          order_value: 'desc',
          order_key: 'id'
        }
      }

      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.events = response.data.data
            this.currentPage = response.data.meta.current_page
            this.totalPages = response.data.meta.last_page
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },

    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      this.loadElements(page)
    },
    changeStatus(id, active, isDelete = false) {
      let status
      let message
      if (isDelete) {
        status = 2
        message = '¿Estás seguro de eliminar el evento?'
      } else {
        status = active === 0 ? 1 : 0
        message =
          active === 0
            ? '¿Estás seguro de activar el evento?'
            : '¿Estás seguro de desactivar el evento?'
      }

      const form = {
        url: 'event/change_status',
        id,
        status
      }

      Swal.fire({
        title: 'Advertencia',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200 && status === 0) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El estado del evento ha sido desactivado'
                })
                this.loadElements()
              } else if (response.code === 200 && status === 1) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El estado del evento ha sido activado'
                })
                this.loadElements()
              } else if (response.code === 200 && status === 2) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El evento ha sido eliminado'
                })
                this.loadElements()
              }
            })
            .catch((error) => {
              console.error(error)
            })
        }
      })
    },
    goNew() {
      this.$router.push({ name: this.buttonNewUrl })
    },
    goEdit(id) {
      this.$router.push({ name: this.buttonEditUrl, params: { id: id } })
    }
  },
  mounted() {
    this.loadElements()
  }
}
</script>

<style>
.text-h4 {
  color: #30476c !important;
}
tr:last-child td {
  border-bottom: 1px solid #dee2e6;
}
</style>
